var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXfooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_footer",
    "data-name": "X footer",
    transform: "translate(-2591 2148)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9659",
    "data-name": "Elipse 9659",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(2591 -2148)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(2153.814 -700.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(445.186 -1438.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M-171.948-84.525h3.017l13.322,17.812h-3.017Zm-2.838-1.421,8.52,11.392-8.574,9.262h1.93L-165.4-73.4l6.065,8.109h6.567l-9-12.033,7.981-8.622h-1.93l-6.913,7.469-5.586-7.469Z",
    transform: "translate(174.84 85.946)",
    fill: "#224a8d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXfooter);
export default __webpack_public_path__ + "static/media/Xfooter.ed0012dd2f68db1a7421446204e71ee3.svg";
export { ForwardRef as ReactComponent };